// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-tag[data-v-eff62dce] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
